import React, { useState, useEffect } from "react";
import { getRequest } from "../../services";
import { Spin } from "antd";
import { Eye } from "lucide-react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const GradeTable = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [examData, setExamData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const { studentGrade, detail } = examData;
  const { filteredExamsId } = props;

  const handlePagination = (direction) => {
    setCurrentPage((prev) =>
      direction === "next" ? prev + 1 : prev - 1
    );
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getRequest(`/api/Grades/StudentGrades?examId=${filteredExamsId[currentPage].id}&examType=Assignment`);
      const data = response.data;
      setExamData(data);
    } catch (error) {
      console.error(t("Error fetching data:"), error.message);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, filteredExamsId]);

  return (
    <>
      <Spin spinning={loading}>
        {examData === 'no grades found' ? (
          <div className="text-center my-4">
            <h4>{t("ExamIsNotPublish")}</h4>
          </div>
        ) : (
          <>
            <div className="container mt-2">
              <table className="table-bordered mb-0 border text-center">
                <tbody>
                  <tr>
                    <th className="p-0 align-middle fw-bold">{t("SubjectName")}</th>
                    <td className="p-0 align-middle">{filteredExamsId[0]?.subjectDetails?.subjectName}</td>
                    <th className="p-0 align-middle fw-bold">{t("ExamTitle")}</th>
                    <td className="p-0 align-middle">{filteredExamsId[0]?.title}</td>
                  </tr>
                  <tr>
                    <th className="p-0 align-middle fw-bold">{t("Date")}</th>
                    <td className="p-0 align-middle">{new Date(studentGrade?.createdAt).toLocaleDateString()}</td>
                    <th className="p-0 align-middle fw-bold">{t("Time")}</th>
                    <td className="p-0 align-middle">{new Date(studentGrade?.createdAt).toLocaleTimeString()}</td>
                  </tr>
                  <tr>
                    <th className="p-0 align-middle fw-bold">{t("TotalMarks")}</th>
                    <td className="p-0 align-middle">{studentGrade?.totalMarks}</td>
                    <th className="p-0 align-middle fw-bold">{t("ObtainedMarks")}</th>
                    <td className="p-0 align-middle">{studentGrade?.marksObtained}</td>
                  </tr>
                  <tr>
                    <th className="p-0 align-middle fw-bold">{t("Completion")}</th>
                    <td className="p-0 align-middle">{studentGrade?.percentage}%</td>
                    <th className="p-0 align-middle fw-bold">{t("Remark")}</th>
                    <td className="p-0 align-middle">{studentGrade?.remarks}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="container-table100 mt-3">
              <div className="wrap-table100">
                <div className="ver5 m-b-110">
                  <div className="table100-body">
                    <table>
                      <tbody>
                        {detail && detail.length > 0 ? (
                          <div className="bg-gray-50 rounded p-6">
                            {detail.map((item, index) => (
                              <div key={index} className="mb-4 border-b pb-4 border-gray-200">
                                <p>
                                  <strong>{t("File")}:</strong>{" "}
                                  <a
                                    href={item.submissions.fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary-600"
                                  >
                                    {t("ViewFile")} <Eye size={16} className="inline-block ml-1" />
                                  </a>
                                </p>
                                <p><strong>{t("Marks")}: </strong>{`${studentGrade.marksObtained}/${studentGrade.totalMarks}`}</p>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="text-center">{t("Nodataavailable")}</div>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Spin>
      {filteredExamsId.length === 0 ? null :
        <div className="flex justify-center mt-4 pb-4 gap-3 paginationStyle">
          <button
            onClick={() => handlePagination("previous")}
            disabled={currentPage < 1}
            className={`px-3 py-1 bg-[#241763] text-white rounded ${currentPage < 1
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-[#241763] text-white hover:bg-[#241763]"}`
            }
          >
            <LeftOutlined />    
          </button>
          <span className="bg-[#241763] text-white px-3 py-1 mx-1 border rounded d-flex align-items-center">
            {`${currentPage + 1}/${filteredExamsId.length}`}
          </span>
          <button
            onClick={() => handlePagination("next")}
            disabled={currentPage >= filteredExamsId.length - 1}
            className={`px-4 py-2 rounded ${currentPage >= filteredExamsId.length - 1
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-[#241763] text-white hover:bg-[#241763]"}`
            }
          >
            <RightOutlined />
          </button>
        </div>
      }
    </>
  );
};

export default GradeTable;
